import React, { useLayoutEffect, useState } from 'react';

import * as S from './styles';
import { DataFormProps } from 'types/InputsGridOfBannersProps';
import SimpleInput from 'components/SimpleInput';
import Check from 'components/Buttons/Check';
import { formatDateToISO, formatToDateCustom } from 'utils/functions';

interface DataFormCarouselBannersProps {
	dataForm: DataFormProps;
	setDataForm: React.Dispatch<React.SetStateAction<DataFormProps>>;
	isShow: boolean;
}

export default function DataFormGridOfBanners({
	isShow,
	dataForm,
	setDataForm
}: DataFormCarouselBannersProps) {
	const [isShowDateInputs, setIsShowDateInputs] = useState(false);

	useLayoutEffect(() => {
		if (!isShowDateInputs) {
			setDataForm((obj) => ({
				...obj,
				countdown: false,
				schedule_start: '',
				schedule_end: ''
			}));
		}
	}, [isShowDateInputs]);

	useLayoutEffect(() => {
		if (dataForm.schedule_start !== '') {
			setIsShowDateInputs(true);
		}
	}, [dataForm]);

	return (
		<S.container $isShow={isShow}>
			<S.twoInputs>
				<SimpleInput
					label="Título *"
					initialValue={dataForm.name}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, name: value }));
					}}
				/>
				<SimpleInput
					label="Subtítulo "
					initialValue={dataForm.description}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, description: value }));
					}}
				/>
			</S.twoInputs>

			<S.line />

			<S.title>
				<p>Personalizar</p>
			</S.title>

			<S.twoInputs>
				<SimpleInput
					paddingInLineEnd
					typeInput="number"
					label="Altura (px)*"
					initialValue={dataForm.height}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, height: value }));
					}}
				/>
				<SimpleInput
					paddingInLineEnd
					typeInput="number"
					label="Espaço entre os banners *"
					initialValue={dataForm.gap}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, gap: parseInt(value) }));
					}}
				/>
			</S.twoInputs>

			<S.threeInputs>
				<SimpleInput
					paddingInLineEnd
					typeInput="number"
					label="Padding vertical *"
					initialValue={dataForm.vertical_padding}
					getValue={(value: string) => {
						setDataForm((obj) => ({
							...obj,
							vertical_padding: parseInt(value)
						}));
					}}
				/>
				<SimpleInput
					paddingInLineEnd
					typeInput="number"
					label="Padding horizontal *"
					initialValue={dataForm.horizontal_padding}
					getValue={(value: string) => {
						setDataForm((obj) => ({
							...obj,
							horizontal_padding: parseInt(value)
						}));
					}}
				/>
				<SimpleInput
					paddingInLineEnd
					typeInput="number"
					label="Arredondamento *"
					initialValue={dataForm.rounded_size}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, rounded_size: parseInt(value) }));
					}}
				/>
			</S.threeInputs>

			<div style={{ display: 'none' }}>
				<Check
					text="Programação"
					isChecked={isShowDateInputs}
					setIsChecked={() => {
						setIsShowDateInputs((obj) => !obj);
					}}
				/>

				{isShowDateInputs && (
					<>
						<S.twoInputs>
							<SimpleInput
								typeInput="datetime-local"
								label="Fim"
								initialValue={
									dataForm.schedule_start === ''
										? ''
										: formatToDateCustom(dataForm.schedule_start)
								}
								getValue={(value: string) => {
									setDataForm((obj) => {
										return {
											...obj,
											schedule_start: formatDateToISO(value)
										};
									});
								}}
								paddingInLineEnd
							/>

							<SimpleInput
								typeInput="datetime-local"
								label="Fim"
								initialValue={
									dataForm.schedule_end === ''
										? ''
										: formatToDateCustom(dataForm.schedule_end)
								}
								getValue={(value: string) => {
									setDataForm((obj) => {
										return {
											...obj,
											schedule_end: formatDateToISO(value)
										};
									});
								}}
								paddingInLineEnd
							/>
						</S.twoInputs>

						<Check
							text="Contagem regressiva"
							isChecked={dataForm.countdown}
							setIsChecked={() => {
								setDataForm((obj) => {
									return {
										...obj,
										countdown: !obj.countdown
									};
								});
							}}
						/>
					</>
				)}
			</div>
		</S.container>
	);
}
